export default __webpack_public_path__ + "static/media/arrow.923e7085.svg";